<script setup lang="ts">
import { ComboboxGroup, ComboboxLabel } from 'reka-ui';

interface Props {
    label?: string;
}
defineProps<Props>();
</script>

<template>
    <combobox-group>
        <combobox-label
            v-if="label"
            class="px-4 text-xs leading-[25px] text-gray-700"
        >
            {{ label }}
        </combobox-label>
        <slot />
    </combobox-group>
</template>
